import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-91">
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-radial-gold opacity-60 pointer-events-none" data-id="element-92" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-94">
          <span className="inline-block py-1 px-3 rounded-full border border-gold-500/30 text-gold-300 text-xs font-medium tracking-widest uppercase mb-6 bg-navy-800/50 backdrop-blur-sm" data-id="element-95">
            Para Empáticos y Personas Altamente Sensibles
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6 text-glow" data-id="element-96">
            Deja de ser una "esponja emocional" y recupera tu energía en 3
            minutos.
          </h1>

          <h2 className="text-xl md:text-2xl text-gold-300 font-serif italic mb-8 max-w-3xl mx-auto" data-id="element-97">
            El Protocolo 11:11: El método de blindaje energético para empáticos
            y profesionales que absorben la negatividad de su entorno.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-12" data-id="element-98">
          <p className="text-base md:text-lg text-gray-300 leading-relaxed max-w-3xl mx-auto font-light" data-id="element-99">
            ¿Alguna vez has salido de una reunión, una cena familiar o un centro
            comercial sintiéndote físicamente agotado, con un peso en los
            hombros o un dolor de cabeza que no estaba ahí hace una hora? No es
            cansancio normal. Es "vampirismo energético" y está drenando tu
            vitalidad, tu paciencia y tu salud sin que te des cuenta.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col items-center gap-4" data-id="element-100">
          <CTAButton onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-101">
            Quiero mi blindaje ahora
          </CTAButton>
          <p className="text-xs text-gray-400 flex items-center gap-2" data-id="element-102">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-103"></span>
            Acceso inmediato tras el pago
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 1,
      delay: 0.6
    }} className="mt-16 w-full max-w-5xl mx-auto relative" data-id="element-104">
        <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-transparent to-transparent z-10" data-id="element-105" />
        <img src="https://cdn.magicpatterns.com/uploads/9UdNJotgKStSfvrpibjTaT/Mockup.png" alt="Protocolo 11:11 en múltiples dispositivos" className="w-full h-auto object-cover rounded-xl shadow-2xl border border-navy-700/50" data-id="element-106" />
      </motion.div>
    </section>;
}